import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/Product/Line/Team/Order/';

const state = {};

const mutations = {};

const actions = {

  CheckMyOrder({commit}, view) {
    return request.PromiseCall(basePath, 'CheckMyOrder', view);
  },
  GetByTree({commit}, view) {
    return request.PromiseCall(basePath, 'GetByTree', view);
  },
  Booking({commit}, view) {
    return request.PromiseCall(basePath, 'Booking', view);
  },

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Product/Line/Team/Order/index.js